export default class TiposDeComponentesEnum {
  static Blank = 0
  static TextBox = 1
  static RadioGroup = 2
  static CheckBox = 3
  static DropDownList = 4
  static DropDownListEncadeado = 5
  static BotaoEmail = 6
  static Label = 7
  static Arquivo = 8
  static Assinatura = 9
  static Numerico = 10
}
